export const OPEN_CRYPTA_GROUP_FAMILY_EDITOR =
    'OPEN_CRYPTA_GROUP_FAMILY_EDITOR';
export type OPEN_CRYPTA_GROUP_FAMILY_EDITOR = typeof OPEN_CRYPTA_GROUP_FAMILY_EDITOR;

export interface OpenCryptaGroupFamilyEditor {
    type: OPEN_CRYPTA_GROUP_FAMILY_EDITOR;
    id: string;
    itemsId: string[];
}

export function openCryptaGroupFamilyEditor(
    id: string,
    itemsId: string[]
): OpenCryptaGroupFamilyEditor {
    return {
        type: OPEN_CRYPTA_GROUP_FAMILY_EDITOR,
        id,
        itemsId
    };
}

export const CLOSE_CRYPTA_GROUP_FAMILY_EDITOR =
    'CLOSE_CRYPTA_GROUP_FAMILY_EDITOR';
export type CLOSE_CRYPTA_GROUP_FAMILY_EDITOR = typeof CLOSE_CRYPTA_GROUP_FAMILY_EDITOR;

export interface CloseCryptaGroupFamilyEditor {
    type: CLOSE_CRYPTA_GROUP_FAMILY_EDITOR;
    id: string;
    itemsId?: string[];
}

export function closeCryptaGroupFamilyEditor(
    id: string,
    itemsId?: string[]
): CloseCryptaGroupFamilyEditor {
    return {
        type: CLOSE_CRYPTA_GROUP_FAMILY_EDITOR,
        id,
        itemsId
    };
}

export const CHANGE_ITEM_CRYPTA_GROUP_FAMILY =
    'CHANGE_ITEM_CRYPTA_GROUP_FAMILY';
export type CHANGE_ITEM_CRYPTA_GROUP_FAMILY = typeof CHANGE_ITEM_CRYPTA_GROUP_FAMILY;

export interface ChangeItemCryptaGroupFamily {
    type: CHANGE_ITEM_CRYPTA_GROUP_FAMILY;
    id: string;
    itemId: string;
}

export function changeItemCryptaGroupFamily(
    id: string,
    itemId: string
): ChangeItemCryptaGroupFamily {
    return {
        type: CHANGE_ITEM_CRYPTA_GROUP_FAMILY,
        id,
        itemId
    };
}

export const SAVE_CRYPTA_GROUP_FAMILY = 'SAVE_CRYPTA_GROUP_FAMILY';
export type SAVE_CRYPTA_GROUP_FAMILY = typeof SAVE_CRYPTA_GROUP_FAMILY;

export interface SaveCryptaGroupFamily {
    type: SAVE_CRYPTA_GROUP_FAMILY;
    id: string;
}

export function saveCryptaGroupFamily(id: string): SaveCryptaGroupFamily {
    return {
        type: SAVE_CRYPTA_GROUP_FAMILY,
        id
    };
}

export type CryptaGroupFamilyEditorAction =
    | CloseCryptaGroupFamilyEditor
    | OpenCryptaGroupFamilyEditor
    | ChangeItemCryptaGroupFamily
    | SaveCryptaGroupFamily;
